import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: [
    './success.component.scss',
    '../../../shared/styles/modern-page-layout.scss'
  ]
})
export class SuccessComponent implements OnInit {
  public title: string;
  public message: string;
  public downloadUrl: string;
  public downloadText: string;
  public isError: boolean = false;
  public isDelegateApproval: boolean = false;
  public delegateEmail: string = '';
  public onboardingUserEmail: string = '';

  constructor(
    private actRoute: ActivatedRoute,
  ) {

}

  ngOnInit() {
    this.actRoute.queryParams
      .subscribe(params => {
        console.log(params);
        this.title = params.title;
        this.message = params.message;
        this.downloadUrl = params.downloadUrl;
        this.downloadText = params.downloadText;

        // Detect error state
        this.isError = params.type === 'error';

        // Detect delegate approval (delegate email is present in state)
        this.delegateEmail = params.delegateEmail || '';
        this.onboardingUserEmail = params.onboardingUserEmail || '';
        this.isDelegateApproval = !!this.delegateEmail;

        // Customize message for delegate approval
        if (this.isDelegateApproval && !this.isError) {
          if (!this.message) {
            this.message = `Thank you for approving the workspace! Please notify ${this.onboardingUserEmail} that the approval is complete and they can continue their setup.`;
          }
        }
      }
    );
 }

}
